// DS: 8.2.1 Simple Footer
import React from 'react';
import c from 'classnames';
import BrandedButton from '../../Buttons/BrandedButton';
import s from './PopoverSimpleFooter.scss';
const PopoverSimpleFooter = ({ message , label , biData , onClick  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['message']
    }, message), /*#__PURE__*/ React.createElement(BrandedButton, {
        size: "medium",
        variant: "brand-green",
        onClick: onClick,
        fillContainerWidth: true,
        biData: biData
    }, label));
};
PopoverSimpleFooter.displayName = 'PopoverSimpleFooter';
export default PopoverSimpleFooter;
